export default __webpack_public_path__ + "static/77-f65c1b6c8f4b146e6eaf0500d86d7caf.jpg";